import styled from "styled-components";

import Loader from "components/Layout/Loader";
import RowDefault from "components/Form/Row";

import { MEDIA_QUERIES } from "constants/layout";

const FORM_HEIGHT = {
  DESKTOP: "410px",
  SMALL_DESKTOP: "370px",
};

export const Container = styled.div`
  width: 580px;
  margin-bottom: 40px;
`;

export const Row = styled(RowDefault)`
  ${MEDIA_QUERIES.SMALL_DESKTOP} {
    margin-bottom: 20px;
  }
`;

export const CardListRow = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 40px;

  max-height: calc(100vh - ${FORM_HEIGHT.DESKTOP});
  overflow-y: auto;

  ${MEDIA_QUERIES.SMALL_DESKTOP} {
    margin-bottom: 20px;
    max-height: calc(100vh - ${FORM_HEIGHT.SMALL_DESKTOP});
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SubtitleContainer = styled.div`
  margin-top: 10px;
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

export const ButtonContainer = styled.div`
  display: flex;

  width: 100px;

  &:not(:last-child) {
    margin-right: 30px;
  }
`;

export const SearchControls = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  margin-left: 32px;
`;

export const SearchControlWrapper = styled.div`
  &:not(:last-child) {
    margin-right: 10px;
  }
`;

export const ScrollLoader = styled(Loader)`
  height: 100px;
`;
